import { isMaintenanceActive } from 'src/utils/maintenance';

import { responseHandler } from './responseHandler';
import { reFetchAuthToken } from './user.service';
import { getAuth, getPrNumberHeader } from './utils';

const request = async (url, { method, headers, payload, withAuth = true }) => {
  // 維護中不把請求送進後端(已開著的 tab / 首屏 effect 都會走到這裡)
  if (isMaintenanceActive()) {
    throw new Error('maintenance');
  }

  const auth = getAuth();

  return fetch(url, {
    method,
    headers: {
      ...(withAuth && auth),
      ...getPrNumberHeader(),
      ...headers,
    },
    ...(payload && { body: JSON.stringify(payload) }),
  })
    .then(responseHandler)
    .catch(async (err) => {
      if (err === 'Jwt is expired') {
        await reFetchAuthToken();
        return request(url, { method, headers, payload });
      } else {
        throw err;
      }
    });
};

export default request;
